import 'UTILS/jsBridge.js';
import { getQueryString } from 'UTILS/utils';
import { cookies } from 'UTILS/localCache';
import { browser } from 'UTILS/browser';
import { envConf, envData } from 'ENV';
import { INAPP } from 'JS/common';

let ENV = envData.ENV;
let pbENV = envData.pbENV; // 专门用于protobuf判断环境用

// 配置环境 prod, beta(beta|pre|audit), alpha
let isLocal = /(localhost|10\.|0\.0|192\.168|172\.)/.test(location.origin);
let checkDomain = location.host; // 使用二级域名带有beta，有可能是beta服
let isAlpha = ENV === 'alpha';
let isBeta = ENV === 'beta';
let isStaging = ENV === 'staging';
// 特殊处理测试服的pre和audit
let isPre = ENV === 'pre';
let isPreTx = ENV === 'pre-tx' && 'pre-tx';
let isBetaTx = ENV === 'beta-tx' && 'beta-tx';
let isTxEnv = isPreTx || isBetaTx;
let isTx = ENV === 'tx';
let isGray = ENV === 'gray';
let isProd = ENV === 'prod';

// 项目文件名(oxygen|caramel)
const project = process.env.project;
// 开启debug,输出每次请求数据
const isDebug = /debug=1/.test(window.location.href);
// 开启log,将请求转向调试接口
const isTestHttps = /testHttps=1/.test(window.location.href);
// 开启Mock数据
const isMock = /mock=1/.test(window.location.href);
// 取消屏蔽log
!isProd && isDebug && window.kerkee && window.kerkee.closeJSLog();

// 项目配置
const curProject = envConf;
const curScheme = curProject['secheme'] || '';
const curServerHost = curProject['serverHost'] || 'mizhua';
const curWxName = curProject['wxName'] || '';
const curAppId = ENV === 'prod' ? curProject['appId'] : curProject['appIdBeta'] || curProject['appId'];
const curProjectName = curProject['name'] || '';
const curProjectId = curProject['projectId'] || 1001;
const curQQ = curProject['qq'] || '';
const curDownloadInfo = curProject['downloadInfo'] || { androidUrl: '', iosUrl: '' };
const pcWeb = curProject['PC'] || {};
const curPCWeb = ['prod', ''].indexOf(ENV) > -1 ? pcWeb['prod'] : pcWeb['beta'];
const imgDomain = !/(localhost|0\.0|192\.168|172\.)/.test(location.origin) ? location.origin : curProject.OSS || '';
// 请求域名
let REQUESTDOMAIN = curProject.API;
const setDomain = (str) => (REQUESTDOMAIN = str);

// 常量URL
const ORIGIN = isLocal ? envConf.OSS : location.origin;
const PRE = `${ORIGIN}/${envData.ENV + (isTxEnv ? '-tx' : '')}/${project}`;
const SELFRESOURCE = ORIGIN + location.pathname;
const SELFPAGE = SELFRESOURCE + location.search;
const RESOURCEPATH = `${ORIGIN}/${envData.ENV}/${project}/commonality/assets`;
const RESOURCEJSON = `${RESOURCEPATH}/json`;
const RESOURCEIMG = `${RESOURCEPATH}/img`;

// 请求OSS域名
const OSSDOMAIN = curProject['OSS'];
const RESOSSDOMAIN = curProject['RESCDN'] || OSSDOMAIN;

if (isDebug) {
  const script = document.createElement('script');
  script.onload = () => {
    eruda.init();
    isDebug && logEnv();
  };
  script.src = `${isLocal ? OSSDOMAIN : location.origin}/${envData.ENV}/${project}/commonality/assets/js/eruda.2.4.1.js`;
  document.getElementsByTagName('head')[0].appendChild(script);
}

// CDN域名
let CDNDOMAIN = curProject.OSS || REQUESTDOMAIN;

// 活动ID
const ACTIVITYID = +getQueryString('id');
// 拼图礼物id
const GIFTID = +getQueryString('gid');

// KEY
let KEY = ((env) => {
  return (
    localStorage.getItem('_key_') ||
    getQueryString('key') ||
    {
      alpha: '',
      beta: '',
      prod: '',
    }[env]
  );
})(ENV);
let APPDATA;

/**
 * 初始化获取key
 * @params { Number } timeout, 超时时间,可选
 * returns { Promise }
 */
let getKeyTime = 0;
let getKeyTimer = null;
let getKey = function (timeout) {
  getKeyTime = +new Date();
  if (timeout) {
    clearTimeout(getKeyTimer);
  }

  return new Promise((resolve, reject) => {
    let cookieKey = cookies.getCookie('loginKey') || null;
    if (window.isSupBrowser === 1 && window.isInApp === false && cookieKey) {
      KEY = cookieKey;
      getKeyTime = 0;
      isDebug && logEnv();
      return resolve(cookieKey);
    }

    // 初始化获取key的方法，用于pc调试
    if (isLocal) {
      // 接口获取KEY使用
      const url = {
        oxygen: '/oxygenkey/dev/login.html?flash=true&name=test',
        redPomelo: '/oxygenkey/dev/login.html?flash=true&name=test',
        caramel: '/caramelkey/dev/login.html?flash=true&name=test',
        miya: '/miyakey/dev/login.html',
        heitang: '/heitangkey/dev/login.html?flash=true&name=test',
        manman: '/manmankey/dev/login.html?flash=true&name=test',
      };
      if (KEY) {
        getKeyTime = 0;
        isDebug && logEnv();
        resolve(KEY);
      } else {
        jsBridgeClient.initData(function (el) {
          clearTimeout(getKeyTimer);
          APPDATA = el;
          KEY = el.key;
          REQUESTDOMAIN = el.shortlink_host || REQUESTDOMAIN;
          getKeyTime = +new Date() - getKeyTime;
          isDebug && logEnv();
          resolve(KEY);
        });

        if (timeout) {
          // 2.5s判断登录失败
          getKeyTimer = setTimeout(function () {
            reject('请先登录');
          }, timeout);
        }
      }
    } else {
      if (!KEY) {
        jsBridgeClient.initData(function (el) {
          clearTimeout(getKeyTimer);
          APPDATA = el;
          KEY = el.key;
          REQUESTDOMAIN = el.shortlink_host || REQUESTDOMAIN;
          getKeyTime = +new Date() - getKeyTime;
          isDebug && logEnv();
          resolve(KEY);
        });

        if (timeout) {
          // 2.5s判断登录失败
          getKeyTimer = setTimeout(function () {
            reject('请先登录');
          }, timeout);
        }
      } else {
        getKeyTime = 0;
        isDebug && logEnv();
        resolve(KEY);
      }
    }
  });
};

const setKey = (key) => (KEY = key);

// TODO TAPD ID: 1048843
let DEVICEID = '';
let deviceIdTimer = null;
let getDeviceIdTime = 0;
const logDevice = function() {
  isDebug && console.log({ DEVICEID, getDeviceIdTime });
};
/**
 * 获取设备ID
 * @param {*} timeout 
 */
const getDeviceId = function (timeout) {
  getDeviceIdTime = +new Date();
  if (timeout) {
    clearTimeout(deviceIdTimer);
  }
  return new Promise((resolve, reject) => {
    if (INAPP) {
      if (DEVICEID) {
        getDeviceIdTime = 0;
        logDevice();
        resolve(DEVICEID);
      } else {
        jsBridgeClient.getDeviceID(function (deviceId) {
          clearTimeout(deviceIdTimer);
          DEVICEID = deviceId;
          getDeviceIdTime = +new Date() - getDeviceIdTime;
          // TODO 为了保证日志在控制台显示必须在eruda初始化之后再log
          setTimeout(() => {
            logDevice();
          }, 1000);
          resolve(DEVICEID);
        });

        deviceIdTimer = setTimeout(() => {
          getDeviceIdTime = 0;
          logDevice();
          resolve(DEVICEID);
        }, timeout || 2000);
      }
    } else {
      resolve(DEVICEID)
    }
  })
}

// 兼容旧版
getKey();
let isInit = false;
function logEnv() {
  if (KEY && !isInit) {
    isInit = true;
    console.log('访问地址:', location.href);
    console.log('请求地址:', REQUESTDOMAIN);
    console.log('运行产品:', project);
    console.log('运行环境:', ENV);
    console.log('活动ID:', ACTIVITYID);
    console.log('GIFTID:', GIFTID);
    console.log('APPDATA: ', APPDATA);
    console.log('KEY:', KEY);
    console.log('getKeyTime:', getKeyTime);
  }
}
export {
  pbENV,
  ENV,
  isProd,
  isGray,
  isLocal,
  isPre,
  isTxEnv,
  isTx,
  imgDomain,
  ACTIVITYID,
  GIFTID,
  KEY,
  APPDATA,
  getKey,
  setKey,
  OSSDOMAIN,
  RESOSSDOMAIN,
  REQUESTDOMAIN,
  isDebug,
  isTestHttps,
  isMock,
  project,
  CDNDOMAIN,
  curProject,
  curProjectName, // 项目名称
  curProjectId, // 项目ID
  curScheme, // 项目scheme
  curWxName, // 公众号
  curAppId, // 公众号appId
  curQQ, // qq客服号
  curDownloadInfo, // 下载链接
  curServerHost,
  curPCWeb, // PC端链接
  setDomain,
  getKeyTime,
  ORIGIN,
  PRE,
  SELFRESOURCE,
  SELFPAGE,
  RESOURCEPATH,
  RESOURCEJSON,
  RESOURCEIMG,
  DEVICEID,
  getDeviceId,
};
